import { FaCheckCircle, FaBolt } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import "../Assets/Css/product.css";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Image,
  Modal,
  Carousel,
} from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet";
import { Card } from "react-bootstrap";
import productImage from "../Assets/Images/your-product.jpg";
import axios from "axios";
import { toast } from "react-hot-toast";
import { BASE_URL } from "../BaseURL";
import "../Assets/Css/contact.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import weldingImg from "../Assets/Image/resistance-welding.jpg";
import laserImg from "../Assets/Image/fiber-laser.jpg";
import waterJetImg from "../Assets/Image/water-jet.jpg";
import product1 from "../Assets/Images/product1.jpg";
import product2 from "../Assets/Images/product2.jpg";
import product3 from "../Assets/Images/product3.jpg";
import product4 from "../Assets/Images/product4.jpg";
import product6 from "../Assets/Images/product6.jpg";
import product7 from "../Assets/Images/product7.jpg";
import product8 from "../Assets/Images/product8.jpg";
import product9 from "../Assets/Images/product9.jpg";
import product10 from "../Assets/Images/product10.jpg";
import product11 from "../Assets/Images/product11.jpg";
import product12 from "../Assets/Images/product12.jpg";
import product13 from "../Assets/Images/product13.jpg";
import product14 from "../Assets/Images/product14.jpg";
import product15 from "../Assets/Images/product15.jpg";
import product16 from "../Assets/Images/product16.jpg";
import product17 from "../Assets/Images/product17.jpg";
import product18 from "../Assets/Images/product18.jpg";
import product19 from "../Assets/Images/product19.jpg";
import product20 from "../Assets/Images/product20.jpg";
import product21 from "../Assets/Images/product21.jpg";
import { Link } from "react-router-dom";
import resistance from "../Assets/Image/resistance.jpg";
import copperLaminated from "../Assets/Image/copper-laminated.jpg";
import copperLaminatedFull from "../Assets/Image/copperlaminatfull1.jpg";
import aluminumLaminated from "../Assets/Image/alumiumlaminated.jpg";
import fabricatedCopper from "../Assets/Image/fabricatedcopper.jpg";
import nonFerrousMachined from "../Assets/Image/stampedNonferrous.jpg";
import subAssemblySwitchgear from "../Assets/Image/subassewitch01.jpg";
import subAssemblyBusbar from "../Assets/Image/subassebts.jpg";
import plugInAssemblies from "../Assets/Image/bts.jpg";
import fishPlates from "../Assets/Image/fish1.jpg";
import stampedNonFerrous from "../Assets/Image/stampedNonferrous1.jpg";
import ferrous from "../Assets/Image/ferrous.jpg";
import silverBrazing from "../Assets/Image/silver01.jpg";
import tinPlated from "../Assets/Image/tin.jpg";
import feederBTS from "../Assets/Image/feeder.jpg";
import pressTools from "../Assets/Image/press.jpg";
export default function ProductShowcase() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const features = [
    "Complete design to delivery support",
    "Manufacturing of Tap-Off Boxes & accessories",
    "Custom busduct solutions for any specification",
    "Quality-tested components with ISO compliance",
  ];

  const applicationAreas = [
    "Manufacturing plants",
    "Logistics & warehousing",
    "Construction sites",
    "Processing units",
  ];

  const Gallery = [
    { image: product1 },
    { image: product2 },
    { image: product3 },
    { image: product4 },
    { image: product6 },
    { image: product7 },
    { image: product8 },
    { image: product9 },
    { image: product10 },
    { image: product11 },
    { image: product12 },
    { image: product13 },
    { image: product14 },
    { image: product15 },
    { image: product16 },
    { image: product17 },
    { image: product18 },
    { image: product19 },
    { image: product20 },
    { image: product21 },
  ];

  const testimonials = [
    {
      message:
        "Delta Engineering transformed our ideas into reality. Their team was professional, responsive, and delivered high-quality solutions on time. Highly recommended!",
      author: "Arjun Patel, CEO",
    },
    {
      message:
        "We were impressed with the technical expertise and dedication of Delta Engineering. The project was seamless, and the results exceeded our expectations",
      author: " Priya Sharma, Operations Manager",
    },
    {
      message:
        "Excellent service and support throughout our project. Delta Engineering is our go-to partner for all engineering and design needs.",
      author: "Vikram Desai, Director",
    },
    {
      message:
        "Professional, detail-oriented, and highly skilled team. We look forward to many more successful collaborations with Delta Engineering.",
      author: " Sneha Verma, Project Lead",
    },
  ];

  const upcomingMachineries = [
    {
      name: "Resistance Welding Machines",
      description: "Launching soon with cutting-edge capabilities.",
      img: weldingImg,
      delay: 0,
      fullDescription: `Resistance Welding Machines are essential for joining laminated copper and aluminium flexible jumpers. They provide distortion-free, energy-efficient bonding and are perfect for transformers, busbars, and terminals.`,
    },
    {
      name: "Fiber Laser Machine",
      description: "Launching soon with cutting-edge capabilities.",
      img: laserImg,
      delay: 150,
      fullDescription: `Fiber Laser Machines deliver fast, high-precision cutting of copper, aluminium, and steel. Ideal for control panels and busbar manufacturing, ensuring minimal material waste and edge burr.`,
    },
    {
      name: "Water Jet Cutting Machines",
      description: "Launching soon with cutting-edge capabilities.",
      img: waterJetImg,
      delay: 300,
      fullDescription: `Water Jet Cutting Machines use high-pressure water streams for cold cutting thick copper and aluminium with no heat-affected zones. Perfect for complex shapes and precise tolerances.`,
    },
  ];

  const products = [
    {
      name: "Copper Laminated Flexibles",
      image: copperLaminated,
      route: "/copper-laminated-flexibles",
      short: "Multi-layered copper for enhanced flexibility.",
      details:
        "Constructed from thin copper foils laminated under high pressure, these connectors are ideal for dynamic installations with high current flow.",
    },
    {
      name: "Fully Tin Plated Copper Flexible",
      image: copperLaminatedFull,
      route: "/copper-lamination-full-tinned",
      short: "Tin-coated copper lamination for corrosion resistance.",
      details:
        "Provides superior conductivity and anti-corrosive properties, widely used in transformers, switchgear, and control panels.",
    },
    {
      name: "Braided Flexibles",
      image: resistance,
      route: "/resistance-welded-flexibles",
      short: "Durable and efficient resistance-welded connections.",
      details:
        "Used in power distribution systems, these connectors are made by welding individual copper strips, offering high conductivity and vibration resistance.",
    },
    {
      name: "Aluminum Laminated Flexibles",
      image: aluminumLaminated,
      route: "/aluminum-laminated-flexibles",
      short: "Lightweight laminated aluminum jumpers.",
      details:
        "Composed of layered aluminum foils, these connectors match the performance of solid bars with a fraction of the weight.",
    },
    {
      name: "Fabricated Copper Busbars",
      image: fabricatedCopper,
      route: "/fabricated-copper-busbars",
      short: "Custom-shaped copper busbars.",
      details:
        "Used in panels and switchboards, these precision-fabricated busbars ensure efficient power distribution with low resistance.",
    },
    {
      name: "Feeder Length For BTS",
      image: feederBTS,
      route: "/feeder-length-for-bts",
      short:
        "Feeder cables made for BTS sites to ensure clear and stable signal transmission.",
      details:
        "These cables connect antennas to base station equipment in mobile networks. They are made to reduce signal loss and are built to handle outdoor conditions.",
    },
    {
      name: "Non-Ferrous Machined Parts",
      image: nonFerrousMachined,
      route: "/non-ferrous-machined-parts",
      short: "Precision non-ferrous components.",
      details:
        "Machined from materials like copper, brass, and aluminum for electrical and thermal applications.",
    },
    {
      name: "Bimetallic Products and Washers",
      image: ferrous,
      route: "/bimetallic-products-and-washers",
      short: "Copper-aluminum bonded products.",
      details:
        "Used in terminals and lugs, combining different metals to balance conductivity and cost.",
    },
    {
      name: "Sub Assemblies - Switchgear",
      image: subAssemblySwitchgear,
      route: "/sub-assemblies-switchgear",
      short: "Switchgear integration components.",
      details:
        "Includes connectors, insulators, and mounting assemblies tailored for switchgear units.",
    },
    {
      name: "Sub Assemblies - Busbar Trunking",
      image: subAssemblyBusbar,
      route: "/sub-assemblies-busbar-trunking",
      short: "Components for busbar trunking systems.",
      details:
        "Pre-engineered solutions for trunking layouts ensuring ease of assembly and reliability.",
    },
    {
      name: "Busbar Trunking - Plug In Assemblies",
      image: plugInAssemblies,
      route: "/busbar-trunking-plug-in-assemblies",
      short: "Modular plug-in units for trunking systems.",
      details:
        "Enables easy load distribution and quick setup in large-scale power layouts.",
    },
    {
      name: "Fish Plates for Busbar Trunking",
      image: fishPlates,
      route: "/fish-plates-for-busbar-trunking",
      short: "Support joints for busbar continuity.",
      details:
        "Connects and secures busbars while maintaining structural and electrical continuity.",
    },
    {
      name: "Stamped Parts - Non Ferrous",
      image: stampedNonFerrous,
      route: "/stamped-parts-non-ferrous",
      short: "Stamped precision parts from non-ferrous metals.",
      details:
        "Used in electrical contacts and thermal solutions with tight tolerances and custom designs.",
    },
    {
      name: "Silver Brazing",
      image: silverBrazing,
      route: "/silver-brazing",
      short: "High-conductivity joints with silver alloy.",
      details:
        "Used for strong, conductive joins in high-temperature electrical systems.",
    },
    {
      name: "Tin/Silver Plated Copper Bars",
      image: tinPlated,
      route: "/tin-silver-plated-copper-bars",
      short: "Anti-corrosive plated copper bars.",
      details:
        "Suitable for harsh environments, combining copper’s conductivity with protective coatings.",
    },
    {
      name: "Press Tools",
      image: pressTools,
      route: "/press-tools",
      short: "Custom tools for stamping and forming.",
      details:
        "Engineered to support mass production of busbars, lugs, and connectors with precision.",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleOpen = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const handleShow = (machine) => {
    console.log("Clicked:", machine.name);
    setSelectedMachine(machine);
    setShowModal(true);
  };

  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [mainImage, setMainImage] = useState(null);

  const handleOpenModal = (flavor) => {
    setSelectedFlavor(flavor);
    setMainImage(flavor.image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedFlavor(null);
    setMainImage(null);
  };
  <Modal show={!!selected} onHide={() => setSelected(null)}></Modal>;

  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const handleOpenInquiryModal = () => {
    setShowModal(false);
    setShowInquiryModal(true);
  };

  const [form, setForm] = useState({
    userName: "",
    mobile: "",
    email: "",
    address: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        productName: selectedFlavor.title,

        ...form,
      };
      await axios.post(`${BASE_URL}/enquiry/sendProductEnquiry`, payload);
      toast.success("Product Inquiry sent successfully!");
      setForm({
        userName: "",
        mobile: "",
        email: "",
        address: "",
        message: "",
      });
      setShowInquiryModal(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to send inquiry.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Our Products | Delta Engineering</title>
        <meta
          name="description"
          content="Explore Delta Engineering’s full range of precision-engineered products including laminated copper flexibles, fabricated busbars, plug-in box assemblies, stamped parts, and complete sub-assemblies."
        />
        <meta
          name="keywords"
          content="Delta Engineering, laminated copper connectors, fabricated busbars, plug-in boxes, copper busbars, stamped parts, sub-assemblies, switchgear, BTS, power sector, copper foils, press tools, fiber laser machine, resistance welding, water jet cutting"
        />
        <meta name="author" content="Delta Engineering" />
        <meta property="og:title" content="Our Products | Delta Engineering" />
        <meta
          property="og:description"
          content="Discover our innovative and high-quality product solutions designed for the power distribution and engineering industries."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://deltaengnsk.com/products" />
        <meta
          property="og:image"
          content="https://deltaengnsk.com/assets/images/og-products.jpg"
        />
      </Helmet>
      <section className="banner4-section text-white d-flex align-items-center justify-content-center text-center position-relative">
        <div className="overlay-layer"></div>

        <div className="banner2-overlay px-3 position-relative">
          <h2 className="banner2-title" data-aos="zoom-in" data-aos-delay="300">
            Our <span> Products</span>
          </h2>

          <p
            className="banner2-subtitle"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            Powering progress with advanced copper connectors, busbars, and
            precision solutions.
          </p>
        </div>
      </section>
      <section className="our-products-overview py-3 bg-white pt-2">
        <Container>
          <div className="text-center mb-5">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Our Products
              <span className="title-underline"></span>
            </h3>

            <p className="text-muted px-3 px-md-5" data-aos="fade-up">
              We specialize in manufacturing high-quality laminated copper
              flexible connectors, fabricated busbars from copper and aluminium
              as per customer specifications. Our range also supports the Busbar
              Trunking System industry with Plug-in/Tap-off box assemblies,
              joint packs, spring hangers, and other accessories.
            </p>
          </div>
          <section className="product-gallery-section py-5">
            <Container>
              <Row className="g-4 justify-content-center">
                {products.map((product, idx) => (
                  <Col
                    key={idx}
                    md={4}
                    sm={6}
                    xs={12}
                    data-aos="zoom-in-up"
                    data-aos-delay={idx * 100}
                  >
                    <Card
                      className="product-card shadow-sm border-0 h-100 cursor-pointer"
                      onClick={() => navigate(product.route)}
                      style={{ cursor: "pointer" }}
                    >
                      <Card.Img
                        variant="top"
                        src={product.image}
                        alt={product.name}
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <Card.Body>
                        <Card.Title className="fw-bold">
                          {product.name}
                        </Card.Title>
                        <Card.Text className="text-muted mb-2">
                          {product.short}
                        </Card.Text>
                        <Card.Text
                          className="text-muted"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {product.details}
                        </Card.Text>
                      </Card.Body>
                      <div className="text-center mt-3">
                        <Link to={product.route}>
                          <button className="btn btn-outline-primary btn-sm">
                            View More
                          </button>
                        </Link>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Container>
          </section>

          <section className="py-5">
            <Container>
              <Row className="align-items-center g-4">
                <Row className="mb-5 text-center">
                  <Col>
                    <h2
                      className="fw-bold section-title mb-3 text-primary"
                      data-aos="fade-up"
                    >
                      What We Manufacture
                    </h2>
                    <p
                      className="text-muted lead"
                      data-aos="fade-up"
                      data-aos-delay="100"
                    >
                      High-performance engineered electrical components for
                      modern power systems
                    </p>
                  </Col>
                </Row>
                <Col md={6}>
                  <div className="product-image-wrapper shadow rounded overflow-hidden position-relative">
                    <img
                      src={productImage}
                      alt="Our Products"
                      className="img-fluid w-100 rounded"
                      loading="lazy"
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className="ps-md-4">
                    <h3 className="fw-bold text-dark mb-2 ">
                      Our Core Product Segments
                    </h3>

                    <p className="text-muted">
                      This image represents our specialized manufacturing
                      expertise across a broad range of engineered electrical
                      components, designed to meet the high-performance and
                      reliability standards of the power sector.
                    </p>
                    <div className="text-muted">
                      {[
                        {
                          title: "Laminated & Solid Copper Busbars",
                          features: [
                            "Precision-engineered for compact power distribution.",
                            "Ideal for switchgear, control panels, and electrical enclosures.",
                          ],
                        },
                        {
                          title: "Plug-in Box Assemblies & Panel Busducts",
                          features: [
                            "Compact, customizable solutions for electrical connectivity.",
                            "Enhances safety and reduces installation time.",
                          ],
                        },
                        {
                          title: "Flexible Copper Connectors",
                          features: [
                            "Designed for vibration and thermal expansion absorption.",
                            "Commonly used in transformers and high-voltage systems.",
                          ],
                        },
                        {
                          title: "Stamped Busbar Components",
                          features: [
                            "Custom-shaped for exact fit and performance.",
                            "Suitable for compact electrical assemblies.",
                          ],
                        },
                        {
                          title: "Sub-Assemblies & Copper Profiles",
                          features: [
                            "Fabricated components integrated into client systems.",
                            "Developed with precision punching, forming, and finishing.",
                          ],
                        },
                        {
                          title: "Copper Foils & Roll Forms",
                          features: [
                            "Used in EMI shielding, transformers, and flexible circuits.",
                          ],
                        },
                      ].map(({ title, features }, idx) => (
                        <div key={idx}>
                          <h6 className="fw-bold mt-4 text-dark">
                            <FaBolt className="me-2 text-warning" />
                            {title}
                          </h6>
                          <ul className="list-unstyled mb-3">
                            {features.map((feat, i) => (
                              <li key={i}>
                                <FaCheckCircle className="me-2 text-success" />
                                {feat}
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </Container>
      </section>

      <section className="busduct-support-section py-5">
        <Container>
          <div className="text-center mb-4">
            <h3 className="fw-bold section-title" data-aos="fade-down">
              Design & Support to Busduct Industries
              <span className="title-underline"></span>
            </h3>
            <p className="text-muted">
              We do all design and manufacturing of Busduct & Tap‑Off Boxes &
              all accessories required for Busduct assembly.
            </p>
          </div>

          <Carousel
            controls
            indicators={false}
            interval={4000}
            fade
            className="shadow-lg rounded"
          >
            {Gallery.map((item, idx) => (
              <Carousel.Item key={idx}>
                <Row className="align-items-center p-4">
                  <Col md={6} data-aos="fade-right">
                    <Image
                      src={item.image}
                      alt={`Busduct product ${idx + 1}`}
                      fluid
                      rounded
                      className="w-100"
                      style={{ maxHeight: 400, objectFit: "cover" }}
                      loading="lazy"
                    />
                  </Col>

                  <Col md={6} data-aos="fade-left">
                    <h5 className="fw-bold text-primary mb-3">
                      Industrial Busduct Solutions
                    </h5>
                    <p className="text-muted mb-3">
                      Reliable & customized busduct design, assembly, and
                      support services for modern power distribution
                      infrastructure.
                    </p>

                    <div className="mb-3">
                      <h6 className="fw-semibold">Key Features</h6>
                      <ul className="list-unstyled text-muted">
                        {features.map((f, i) => (
                          <li
                            key={i}
                            className="d-flex align-items-center mb-1"
                          >
                            <FaCheckCircle className="me-2 text-success" />
                            {f}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div>
                      <h6 className="fw-semibold">Application Areas</h6>
                      <ul className="list-unstyled text-muted">
                        {applicationAreas.map((a, i) => (
                          <li key={i} className="d-flex align-items-start mb-1">
                            <FaCheckCircle className="me-2 mt-1 text-success" />
                            {a}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section>

      <section className="py-5 product-gallery-section">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} className="text-center">
              <div className="text-center mb-4">
                <h3 className="fw-bold section-title" data-aos="fade-down">
                  Products Gallery
                  <span className="title-underline"></span>
                </h3>
              </div>
            </Col>
          </Row>

          <Row className="g-3" data-aos="fade-up" data-aos-delay="100">
            {Gallery.map((product, idx) => (
              <Col key={idx} xs={12} sm={6} md={4} lg={3}>
                <div
                  className="gallery-image-wrapper"
                  onClick={() => handleOpenModal(idx)}
                >
                  <img
                    src={product.image}
                    alt={`Product ${idx + 1}`}
                    className="img-fluid rounded gallery-image"
                    loading="lazy"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>
      {/* <section className="py-5 bg-light" id="upcoming-machinery">
        <Container>
          <div className="text-center mb-4">
            <h3 className="fw-bold section-title" data-aos="fade-down">
              Upcoming Machineries
              <span className="title-underline"></span>
            </h3>
            <p
              className="upcoming-subtitle"
              data-aos="fade-left"
              data-aos-delay="150"
            >
              Exciting technologies being added to boost our precision and
              productivity.
            </p>
          </div>

          <Row className="g-4 justify-content-center">
            {upcomingMachineries.map((machine, index) => (
              <Col
                key={index}
                md={4}
                sm={6}
                data-aos="zoom-in-up"
                data-aos-delay={machine.delay}
              >
                <Card className="machinery-card shadow-sm border-0 text-center p-3 h-100">
                  <Card.Img
                    variant="top"
                    src={machine.img}
                    className="machinery-img"
                    loading="lazy"
                  />
                  <Card.Body>
                    <h5 className="fw-bold">{machine.name}</h5>
                    <p className="text-muted small">{machine.description}</p>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => handleShow(machine)}
                    >
                      Read More
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          {selectedMachine && (
            <Modal show={showModal} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>{selectedMachine.name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img
                  src={selectedMachine.img}
                  alt={selectedMachine.name}
                  className="img-fluid rounded mb-3"
                />
                <p className="text-muted">{selectedMachine.fullDescription}</p>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </Modal>
          )}
        </Container>
      </section> */}
    </>
  );
}
